// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"6269a994","787":"1b3a8f0a"}[chunkId] + ".chunk.js";
};